import * as React from 'react';
import {connect} from "react-redux";
import {CONTACT_TAB, CONTACT_ACTION} from '../../../Config/appConfig';
import {Auth, Company, CompanyHistory, CompanyId, Email, User, InviteUser, Option} from '../../../Config/dataModel';
import userManagementDispatch from '../../../ReduxRequests/Dispatch/userManagementDispatch';
import authState from '../../../ReduxRequests/State/authState';
import userManagementState from '../../../ReduxRequests/State/userManagementState';
import util from '../../../Util/util';
import CloseButton from '../../Custom/CloseButton';
import ContactTab from '../Tab/ContactTab';
import InvitationDropDown from './InvitationDropDown';
import InvitationTableView from './InvitationTableView';
import InvitationTextField from './InvitationTextField';
import Modal from '../../Modal/Modal';
import {clearErrors, assertTrue, assertAllTrue} from '../../../Util/errorUtil';
import ErrorHandler from '../../ErrorHandler/ErrorHandler';
import * as moment from 'moment';
import '../../../style/invitation.css';

const pageSpinner = require('../../../resource/img/page-loading.gif');
const btnSpinner = require('../../../resource/img/button-loading.gif');

const mapStateToProps = (state) => {
    return {
        ...userManagementState(state),
        ...authState(state)
    }
};

interface InvitationProps {
    currentTab: string,
    auth?: () => Auth,
    isInsurer?: () => boolean,
    fetchAllCompanies?: () => void,
    fetchAllUserInsurers?: () => void,
    fetchSubagentHistory?: () => void,
    addSubagent?: (data: CompanyId) => void,
    deactivateSubagent?: (data: CompanyId) => void,
    fetchAllNormalUsers?: () => void,
    inviteUser?: (data: InviteUser) => void,
    enableUser?: (data: Email) => void,
    reinviteUser?: (data: Email) => void,
    recallInvitation?: (data: Email) => void,
    deactivateUser?: (data: Email) => void,
    grantAdminRight?: (data: Email) => void,
    removeAdminRight?: (data: Email) => void,
    allCompanies?: Company[],
    allUserInsurers?: Company[],
    subagentHistory?: CompanyHistory[],
    manageStatus?: string,
    allNormalUsers?: any
}

interface InvitationState {
    allCompanies: Option[],
    subscribedCompanies: CompanyHistory[],
    users: User[],
    selectedCompany: Option,
    email: string,
    firstName: string,
    lastName: string,
    modalContent: JSX.Element,
    modalType: string,
    rightBtn: string,
    displayModal: boolean,
    userId: string,
    pageLoading: boolean,
    listLoading: boolean,
    contentFetched: boolean,
    updatedTime: moment.Moment
}

class Invitation extends React.Component <InvitationProps, InvitationState> {
    manageUser: boolean = false;

    public constructor(props: InvitationProps) {
        super(props);
        this.state = {
            allCompanies: [],
            subscribedCompanies: [],
            users: [],
            selectedCompany: null,
            email: '',
            firstName: '',
            lastName: '',
            modalContent: null,
            modalType: '',
            rightBtn: '',
            displayModal: false,
            userId: '',
            pageLoading: true,
            listLoading: false,
            contentFetched: false,
            updatedTime: null
        };
        this.changeCompany = this.changeCompany.bind(this);
        this.changeEmail = this.changeEmail.bind(this);
        this.changeName = this.changeName.bind(this);
        this.clickInvite = this.clickInvite.bind(this);
        this.clickCancel = this.clickCancel.bind(this);
        this.onError = this.onError.bind(this);
    }

    componentDidMount() {
        this.getUserInfo(false);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.allUserInsurers !== this.props.allUserInsurers) {
            this.setState({
                users: nextProps.allUserInsurers
            });
        }
        if (nextProps.allCompanies !== this.props.allCompanies) {
            let subagents = [];
            for (let i = 0; i < nextProps.allCompanies.length; i++) {
                const data = nextProps.allCompanies[i];
                if (!data.insurer && !data.td && !data.superUser) subagents.push(util.getCompany(data.shortId, data.displayName));
            }
            this.setState({
                allCompanies: subagents
            });
        }
        if (nextProps.subagentHistory !== this.props.subagentHistory) this.setUsers({subscribedCompanies: nextProps.subagentHistory});
        if (this.manageUser && nextProps.manageStatus) {
            this.manageUser = false;
            this.setState({
                contentFetched: false,
                email: '',
                firstName: '',
                lastName: ''
            });
            this.setDisplayModal(false);
            this.getUserInfo(true);
        }
        if (nextProps.allNormalUsers !== this.props.allNormalUsers) this.setUsers({users: nextProps.allNormalUsers});
    }

    getUserInfo(update: boolean) {
        this.changeUpdatedTime(moment());
        if (this.props.currentTab === CONTACT_TAB.COMPANY) {
            if (this.props.isInsurer()) {
                if (!update) this.props.fetchAllCompanies();
                this.props.fetchSubagentHistory();
            }
            else this.props.fetchAllUserInsurers();
        }
        else this.props.fetchAllNormalUsers();
    }

    public setPageLoading(pageLoading: boolean) {
        this.setState({pageLoading});
    }

    public setListLoading(listLoading: boolean) {
        this.setState({listLoading});
    }

    setUsers(list: any) {
        this.setPageLoading(false);
        this.setListLoading(false);
        this.setState({...list, ...{
            contentFetched: true
        }});
    }

    setDisplayModal(display: boolean) {
        this.setState({
            displayModal: display
        });
    }

    changeUpdatedTime(updatedTime: moment.Moment) {
        this.setState({
            updatedTime
        });
    }

    changeCompany(company: Option) {
        this.setState({
            selectedCompany: company
        });
    }

    changeEmail(event) {
        event.preventDefault();
        this.setState({
            email: event.target.value
        });
    }

    changeName(event) {
        event.preventDefault();
        const target = event.target;
        const value = target.value;
        this.setState({
            ...this.state,
            [target.name]: value.replace(/[^a-zA-Z0-9\.-]/, "")
        });
    }

    clickInvite(event) {
        event.preventDefault();
        clearErrors();
        let user = '';
        let userId = '';
        if (this.props.currentTab === CONTACT_TAB.COMPANY) {
            const nonBlank = assertTrue(150, !!this.state.selectedCompany);
            if (!nonBlank) return;
            const valid = assertTrue(166, !this.state.subscribedCompanies.filter((elem) => elem.shortId === this.state.selectedCompany.value).length);
            if (!valid) return;
            user = this.state.selectedCompany.label;
            userId = this.state.selectedCompany.value;
        }
        else {

            if(!assertTrue(156, this.state.email.length > 0)) return;
            if(!assertTrue(157, this.state.firstName.length > 0)) return;
            if(!assertTrue(158, this.state.lastName.length > 0)) return;
            if(!assertTrue(140, !!util.isValidEmail(this.state.email))) return;

            const valid = assertTrue(160, !this.state.users.filter((elem) => elem.email === this.state.email).length);
            if (!valid) return;
            user = this.state.email;
            userId = this.state.email;
        }
        this.clickAction(user, CONTACT_ACTION.INVITE, userId, null, this.props.currentTab === CONTACT_TAB.COMPANY);
    }

    clickCancel(event) {
        event.preventDefault();
        this.setDisplayModal(false);
    }

    clickConfirm(modalType: string, userId: string) {
        clearErrors();
        this.manageUser = true;
        this.setListLoading(true);
        if (this.props.currentTab === CONTACT_TAB.COMPANY) {
            switch (modalType) {
                case CONTACT_ACTION.DEACTIVATE:
                    this.props.deactivateSubagent({id: userId});
                    break;
                case CONTACT_ACTION.INVITE:
                case CONTACT_ACTION.RECOVER:
                    this.props.addSubagent({id: userId});
                    break;
                default:
                    break;
            }
        }
        else {
            switch (modalType) {
                case CONTACT_ACTION.DEACTIVATE:
                    this.props.deactivateUser({email: userId});
                    break;
                case CONTACT_ACTION.INVITE:
                    const data = {
                        email: this.state.email,
                        companyId: this.props.auth().user.companyCode,
                        firstName: this.state.firstName,
                        lastName: this.state.lastName
                    };
                    this.props.inviteUser(data);
                    break;
                case CONTACT_ACTION.RESEND_INVITATION:
                    this.props.reinviteUser({email: userId});
                    break;
                case CONTACT_ACTION.RECALL_INVITATION:
                    this.props.recallInvitation({email: userId});
                    break;
                case CONTACT_ACTION.RECOVER:
                    this.props.enableUser({email: userId});
                    break;
                case CONTACT_ACTION.CHANGE_ROLE.BE_ADMIN:
                    this.props.grantAdminRight({email: userId});
                    break;
                case CONTACT_ACTION.CHANGE_ROLE.BE_USER:
                    this.props.removeAdminRight({email: userId});
                    break;
                default:
                    break;
            }
        }
    }

    clickAction(user: string, action: string, userId: string, role?: Option, isSubagent?: boolean) {
        this.setDisplayModal(true);
        this.setState({
            modalContent: <div className="cmText modalText modalTextSm">Are you sure you want to {action.toLowerCase()}{action === CONTACT_ACTION.RECALL_INVITATION ? ' from' : ''} {isSubagent ? 'sub-agent' : 'user'}?<br/><br/>{user}</div>,
            modalType: action,
            rightBtn: role ? 'Proceed' : action,
            userId
        });
    }

    getContent() {
        if (this.state.contentFetched || this.state.listLoading) {
            return (
                <div>
                    <div className="invitationContainer">
                        {this.props.currentTab === CONTACT_TAB.COMPANY ?
                            <InvitationDropDown companyOptions={this.state.allCompanies} selectedCompany={this.state.selectedCompany} changeCompany={this.changeCompany}/> :
                            <InvitationTextField
                                email={this.state.email}
                                firstName={this.state.firstName}
                                lastName={this.state.lastName}
                                changeEmail={this.changeEmail}
                                changeName={(name) => this.changeName(name)}/>}
                        <button className="cmBoldText cmCenterBtn cmBlueBtn actionBtn invitationActionBtn" onClick={this.clickInvite} disabled={this.state.pageLoading}>
                            <span className="cmBtnText">{CONTACT_ACTION.INVITE}</span>
                            {this.state.pageLoading &&
                            <img className="cmBtnSpinner" src={btnSpinner}/>}
                        </button>
                    </div>
                    <ErrorHandler onError={this.onError}/>
                    {this.state.contentFetched ?
                        <InvitationTableView
                            currentTab={this.props.currentTab}
                            subscribedCompanies={this.state.subscribedCompanies}
                            users={this.state.users}
                            clickAction={(user, action, userId, role) => this.clickAction(user, action, userId, role)}/> :
                        <img className="cmCenter" src={pageSpinner}/>}
                </div>
            );
        }
        else {
            return (
                <div>
                    <div className="cmBtnCenterSpinner">
                        <ErrorHandler onError={this.onError} displayAtCenter={true}/>
                    </div>
                    {this.state.pageLoading && <img className="cmCenter" src={pageSpinner}/>}
                </div>
            );
        }
    }

    onError() {
        this.setPageLoading(false);
        this.setListLoading(false);
        this.setState({
            displayModal: false
        });
    }

    render() {
        return (
            <div className="cmHorCenter cmFormContainer">
                <div className="cmFormTitleHeader">
                    <ContactTab currentTab={this.props.currentTab} updatedTime={this.state.updatedTime} changeUpdateStatus={() => this.changeUpdatedTime(null)}/>
                    <CloseButton/>
                </div>
                {this.getContent()}
                {this.state.displayModal &&
                <Modal
                    content={this.state.modalContent}
                    leftBtn="Cancel"
                    rightBtn={this.state.rightBtn}
                    clickCancel={this.clickCancel}
                    clickConfirm={(e) => this.clickConfirm(this.state.modalType, this.state.userId)}
                    loading={this.state.listLoading}/>}
            </div>
        );
    }
}

export default connect<any, any, InvitationProps>(mapStateToProps, userManagementDispatch)(Invitation);



// WEBPACK FOOTER //
// ./src/Components/Contact/Invitation/Invitation.tsx